import type { InferReturn, Nullish } from "~/@types/generics"
import getSfMediaVideo from "~/lib/shopify/queries/get-sf-media-video"
import { rTFilledOrNull } from "~/lib/storyblok/utils/check-empty-string"
import serializeImage from "~/components/ui/Image/_data/serializer"
import type { PushEditoFromSchema } from "~/components/ui/PushEdito/_data/schema"
import serializeRoundedCta from "~/components/ui/RoundedCta/_data/serializer"
import { serializeVideo } from "~/components/ui/Video/_data/serializer"

export default async function serializePushEdito(pushEdito: PushEditoFromSchema, locale: Nullish<string>) {
  const [videoDesktop, videoMobile, cta] = await Promise.all([
    getSfMediaVideo(pushEdito.videos?.[0]?.video_desktop?.id),
    getSfMediaVideo(pushEdito.videos?.[0]?.video_mobile?.id),
    serializeRoundedCta(pushEdito.cta[0], locale),
  ])

  return {
    title: rTFilledOrNull(pushEdito.title),
    subtitle: rTFilledOrNull(pushEdito.subtitle),
    isEdito: true,
    tag: pushEdito.tag,
    cta,
    bgColor: pushEdito.bg_color,
    textTheme: pushEdito.text_theme,
    bgImage: pushEdito?.background_image?.[0] ? serializeImage(pushEdito.background_image[0].image) : null,
    videos: {
      desktop: serializeVideo(videoDesktop),
      mobile: serializeVideo(videoMobile),
    },
  }
}

export type TPushEdito = InferReturn<typeof serializePushEdito>
